import { STATUS_TYPE } from "taltech-styleguide";
import {ErrorScreen,  ErrorScreenProps } from "@components-common/errors";
import "@styles/404PageStyles.css"

const UnderDevelopment : React.FC<any> = () => {
  const props: ErrorScreenProps = {
    variant: STATUS_TYPE.INFO,
    status: -0o1,
    title: "Under development",
    message: "The present page is still under development.",
  };
  return <ErrorScreen {...props} />;
};

export {UnderDevelopment};
